import React, { useState, useEffect, useRef } from "react";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useGlobalContext } from "../Config";
import { ConfirmDialog} from "primereact/confirmdialog";
import TableSubproductos from "../components/TableSubproductos";
import FormCrearSubproducto from "../components/FormCrearSubproducto";
import FormEditarSubproducto from "../components/FormEditarSubproducto";
import Loader from "../components/Loader.js";
import { Toast } from 'primereact/toast';

const MantenedorSubproductos = () => {
  const toast = useRef(null);
  const [subproductos, setSubproductos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [displayDialog, setDisplayDialog] = useState(false);
  const [showEditDialog, setShowEditDialog] = useState(false);
  const [selectedSubproducto, setSelectedSubproducto] = useState(null);
  const [descripcion, setDescripcion] = useState("");
  const [id, setId] = useState("");
  const fichaRef = useRef(null);
  const {baseUrl, headerText } = useGlobalContext();
  const idUsuario = sessionStorage.getItem("usuario_id");
  const [unidad, setUnidad] = useState("");
  const [tarifa, setTarifa] = useState("");
  const [empresa, setEmpresas] = useState(null);
  const [listaEmpresas, setListaEmpresas] = useState([]);

  const obtenerEmpresas = async () => {
    try {
      const response = await fetch(`${baseUrl}/getAllEmpresas`);
      const data = await response.json();
      setListaEmpresas(data.empresas);
      if (data.empresas && data.empresas.length > 0) {
        setEmpresas(data.empresas[0].id);
      }
    } catch (error) {
      console.error("Error al obtener las empresas:", error);
    }
  };
  const nombreEmpresa = listaEmpresas.find(item => item.id === empresa)?.nombre;

  const fetchData = async () => {
    try {
      if (empresa) {
        setLoading(true);
        try {
          const response = await fetch(
            `${baseUrl}getSubproductosByEmpresa?empresa=${nombreEmpresa}`
          );
          const data = await response.json();
          setSubproductos(data.subproductos);

        } catch (error) {
          console.error("Error fetching subproductos:", error);
        } finally {
          setLoading(false);
        }
      }
    } catch (error) {
      console.error("Error al obtener los subproductos:", error);
    }
  };

  useEffect(() => {
    obtenerEmpresas();
  }, [baseUrl]);

  useEffect(() => {
    if (empresa) {
      setGlobalFilterValue('');
      fetchData();
    }
  }, [empresa, baseUrl]);

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    setGlobalFilterValue(value);
  };

  const [subproducto, setSubproducto] = useState({
    descripcion: ""
  });
  
  const validateInputs = () => {
    if (!subproducto.descripcion || !unidad) {
      alert("Todos los campos son obligatorios.");
      return false;
    }
    const invalidChars = /[|°!"#$%&/()='?¿¡{}]/;
    if (invalidChars.test(subproducto.descripcion)) {
      alert("La descripción no debe contener caracteres especiales");
      return false;
    }
    
    // Validación: no permitir crear subproductos con misma descripción y unidad
    const descNormalized = (subproducto.descripcion || "")
      .trim()
      .normalize("NFC")
      .toLocaleUpperCase("es-ES");



    const existeDuplicado = subproductos.some((p) => {
      const pDesc = p.descripcion
          ? p.descripcion.trim().normalize("NFC").toLocaleUpperCase("es-ES")
          : "";
      
      return (pDesc === descNormalized && p.unidad === unidad);
    });

    if (existeDuplicado) {
      alert("Ya existe un subproducto con esa descripción.");
      setLoading(false);
      return;
    }

    return true;
  };

  const handleCreateSubproducto = async () => {
    if (!validateInputs()) {
      return;
    }
    try{
      setLoading(true);

      const newSubproducto = {
        empresa: nombreEmpresa,
        descripcion: subproducto.descripcion,
        unidad: unidad,
        idUsuario: idUsuario
      };
      console.log(newSubproducto);
      // Esperar el resultado y obtener el ID del subproducto creado
      const insertedSubproducto = await createSubproductoAPI(newSubproducto);

      const newTarifaSubproducto = {
        idTipoSubproducto: insertedSubproducto.subproducto.id,
        idEmpresa: insertedSubproducto.subproducto.idEmpresa,
        tarifaBase: tarifa,
        idUsuario:idUsuario,
        moneda: "UF"
      };
      await createTarifaSubproductoAPI(newTarifaSubproducto);
      
      setSubproducto({descripcion: ""});
      setUnidad("");
      setTarifa("");
      return insertedSubproducto
    }catch (error) {
      console.error("Error al crear subproducto:", error);
      alert(error.message || "Error al crear subproducto");
      setLoading(false);
      return null;
    }finally{
      fetchData();
      setLoading(false);
      setDisplayDialog(false);
    }
  };

  // AUTOCOMPLETADO DE DIALOG EDITAR SUBPRODUCTO
  const handleEditSubproducto = (subproducto) => {
    setSelectedSubproducto(subproducto);
    setDescripcion(subproducto.descripcion);
    setId(subproducto.id);
    setShowEditDialog(true);
  };

  const createSubproductoAPI = async ({
    empresa,
    descripcion,
    unidad,
    idUsuario
  }) => {
    try {
      const queryParams = new URLSearchParams({
        empresa,
        descripcion,
        unidad,
        idUsuario
      });
      const response = await fetch(
        `${baseUrl}createSubproducto?${queryParams.toString()}`,
        {
          method: "POST",
          headers: headerText,
        }
      );
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.mensaje || "Error al crear subproducto");
      }
      return data;
    } catch (error) {
      console.error("Error al crear subproducto:", error);
      alert(error.message || "Error al crear subproducto");
    }
  };

  const saveSubproductoAPI = async (subproducto) => {
    const response = await fetch(`${baseUrl}updateTipoSubproducto`, {
      method: "PUT",
      headers: headerText,
      body: JSON.stringify(subproducto),
    });
    if (!response.ok) {
      throw new Error("Error saving the subproducto");
    }
    return await response.json();
  };

  const createTarifaSubproductoAPI = async ({
    idTipoSubproducto,
    idEmpresa,
    tarifaBase,
    idUsuario,
    moneda
  }) => {
    try {
      const queryParams = new URLSearchParams({
        idTipoSubproducto,
        idEmpresa,
        tarifaBase,
        idUsuario,
        moneda
      });

      const response = await fetch(
        `${baseUrl}insertTarifaSubproducto?${queryParams.toString()}`,
        {
          method: "POST",
          headers: headerText,
          credentials: 'include'
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.mensaje || "Error al crear subproducto");
      }

      toast.current.show({ severity: 'success', summary: 'Success', detail: 'Subproducto creado exitosamente.' });
      return data;
    } catch (error) {
      console.error("Error al crear tarifasubproducto:", error);
      toast.current.show({ severity: 'error', summary: 'Error', detail: error.message || "Error al crear subproducto" });
    }
  }

  const handleSaveSubproducto = async (fichaData) => { 
    try {
      setLoading(true);
      const updatedSubproducto = { 
        id: selectedSubproducto.id,
        descripcion: descripcion,
        idUsuario: idUsuario
      };
      await saveSubproductoAPI(updatedSubproducto);
      
      // Actualizar la ficha del subproducto usando los datos capturados
      if (fichaData && fichaData.perfil && fichaData.fichaJson) {
        const requestBody = {
          idSubproducto: updatedSubproducto.id,
          perfil: fichaData.perfil,
          ficha: fichaData.fichaJson
        };
        
        const responseFicha = await fetch(`${baseUrl}updateTipoSubproductoFicha`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
            "Accept": "application/json; charset=UTF-8"
          },
          body: JSON.stringify(requestBody),
          credentials: 'include'
        });
        
        if (!responseFicha.ok) {
          throw new Error("Error al actualizar la ficha del subproducto");
        }
      }
      
      setSubproducto({ descripcion: ""});
      setShowEditDialog(false);
      toast.current.show({ severity: 'success', summary: 'Success', detail: 'Subproducto actualizado exitosamente.' });
      fetchData();
    } catch (error) {
      console.error("Error al actualizar el subproducto:", error);
      toast.current.show({ severity: 'error', summary: 'Error', detail: error.message || "Error al actualizar el subproducto" });
    }
  };

  //CABECERA
  const renderHeader = () => {
    return (
      <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-2">
        <span className="p-input-icon-left" style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
          <i className="pi pi-search" />
          <InputText
            value={globalFilterValue}
            onChange={(e) => {
              const upperCaseValue = e.target.value.toUpperCase();
              onGlobalFilterChange({ target: { value: upperCaseValue } });
            }}
            placeholder="Buscar por Descripción"
          />
        </span>
        <span className="p-input-icon-left ml-2" style={{display: "flex", alignItems: "center", justifyContent: "flex-end"}}>
          {subproductos?.length} subproductos de {nombreEmpresa}
        </span>
      </div>
    );
  };
  const header = renderHeader();

  return (
    <div className="grid">
      <Toast ref={toast} />
      <div className="col-12">
        <div className="card">
          <h4>Gestión de Tipos de Subproductos</h4>
          <div className="p-field">
            <label htmlFor="empresa">Seleccione Empresa: </label>
            <Dropdown
              id="empresa"
              value={empresa}
              onChange={(e) => setEmpresas(e.value)}
              options={listaEmpresas}
              optionLabel="nombre"
              optionValue="id"
              placeholder="Seleccione Empresa"
              className="p-inputtext-sm"
              style={{ borderRadius: "4px" }}
            />
          </div>
        </div>
        {empresa && (
          <>
            {loading ? (
              <>
                <Loader />
              </>
            ) : (
              <>
                <div className="card">
                  <Button
                    label="Crear Tipo Subproducto"
                    icon="pi pi-plus"
                    className="p-button p-component mr-2 p-button-rounded p-button-primary mb-3"
                    onClick={() => setDisplayDialog(true)}
                    raised
                  />

                    <TableSubproductos
                      header={header}
                      subproductos={subproductos}
                      loading={loading}
                      globalFilterValue={globalFilterValue}
                      handleEditSubproducto={handleEditSubproducto}
                      nombreEmpresa={nombreEmpresa}
                    />

                    <FormCrearSubproducto
                      displayDialog={displayDialog}
                      setDisplayDialog={setDisplayDialog}
                      subproducto={subproducto}
                      setSubproducto={setSubproducto}
                      handleCreateSubproducto={handleCreateSubproducto}
                      baseUrl={baseUrl}
                      empresa={empresa}
                      nombreEmpresa={nombreEmpresa}
                      unidad={unidad}
                      setUnidad={setUnidad}
                      tarifa={tarifa}
                      setTarifa={setTarifa}
                    />

                    <FormEditarSubproducto
                      showEditDialog = {showEditDialog}
                      setShowEditDialog = {setShowEditDialog}
                      subproducto={subproducto}
                      setSubproducto={setSubproducto}
                      handleEditSubproducto={handleEditSubproducto}
                      baseUrl={baseUrl}
                      empresa={empresa}
                      nombreEmpresa={nombreEmpresa}
                      descripcion={descripcion}
                      setDescripcion={setDescripcion}
                      handleSaveSubproducto = {handleSaveSubproducto}
                      fichaRef={fichaRef}
                      id={id}
                    />

                    <ConfirmDialog/>

                </div>
              </>
            )}
          </>
        )}
      </div>
      
    </div>
  );
};
export default MantenedorSubproductos;